import 'reflect-metadata';
import {jsonObject, jsonMember} from 'typedjson';

import {Device} from '@/model/network/device/Device';

@jsonObject
export class DeviceEthernet extends Device {

  @jsonMember({name: 'hardwareAddress'})
  public HardwareAddress!: string;

  @jsonMember({name: 'permanentHardwareAddress'})
  public PermanentHardwareAddress!: string;

  @jsonMember({name: 'speed'})
  public Speed!: number;

  @jsonMember({name: 'hasCarrier'})
  public HasCarrier!: boolean;
}
